import { Row, Col, Modal } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { Card } from "../../components/Card";
import { useNavigate } from 'react-router-dom';
import { useSelectedMenuContext } from '@/@presentation/contexts/selectedMenu';
import apiDashboard from '@/@core/modules/dashboard/infra/container.registry';
import { ISimpleChart, IChartNextDays, IChartResponse } from '@/@core/modules/dashboard/domain/dashboard.entities';
import { useItemsContext } from '@/@presentation/contexts/schedulesContext'
import React from 'react';
import { CardWithChart } from '../../components/CardWithChart';
import popupRegistry from '@/@core/modules/popup/infra/container.registry';

const Home = () => {
    const [schedulesToday, setSchedulesToday] = React.useState<ISimpleChart>({ total: 0 });
    const [schedulesYesterday, setSchedulesYesterday] = React.useState<ISimpleChart>({ total: 0 });
    const [pendingToConfirmation, setPendingToConfirmation] = React.useState<ISimpleChart>({ total: 0 });
    const [pendingToPay, setPendingToPay] = React.useState<ISimpleChart>({ total: 0 });
    const [schedulesNext30Days, setSchedulesNext30Days] = React.useState<IChartResponse>({ result: [], total: 0 });
    const [loadingCharts, setLoadingCharts] = React.useState<boolean>(true);
    const [popupVisible, setPopupVisible] = React.useState<boolean>(false);
    const [popupText, setPopupText] = React.useState<string>('');

    const loadCharts = async () => {
        setLoadingCharts(true);

        const today = await apiDashboard.get.getSchedulesToday();
        const yesterday = await apiDashboard.get.getSchedulesYesterday();
        const pendingToConfirmation = await apiDashboard.get.getSchedulesPendingToConfirmation();
        const pendingToPay = await apiDashboard.get.getSchedulesPendingToPay();
        const next30Days = await apiDashboard.get.getSchedulesNext30Days();

        setSchedulesToday(today);
        setSchedulesYesterday(yesterday);
        setPendingToConfirmation(pendingToConfirmation);
        setPendingToPay(pendingToPay);
        setSchedulesNext30Days(next30Days);

        setLoadingCharts(false);
    }

    const navigate = useNavigate();
    const { setSelectedMenu } = useSelectedMenuContext();

    const {
        setIsRedirect,
        setInitialDate,
        setFinalDate,
        setSurgeon,
        setStatusFilter,
        setLocale,
        setScheduleId,
        setRequester,
        setPatient,
        setCreatedInitial,
        setCreatedFinal,
        setStatusBilling,
    } = useItemsContext()

    const goTo = (page: '/schedule' | '/finance', type?: 'PROCEDURE_TODAY' | 'PROCEDRE_PENDING_TO_PAY' | 'PROCEDURE_TO_COFIRMSTION' | 'PROCEDURE_FINISH_YESTERDAY' | 'PROCEDURE_NEXT_30_DAYS') => {
        setSelectedMenu(page);

        if (type === 'PROCEDURE_TODAY') {
            const today = new Date().toISOString().slice(0, 10)
            setStatusFilter(['pending', 'inProgress', 'confirmed', 'finished', 'rescheduled']);
            setIsRedirect(true);
            setInitialDate(today);
            setFinalDate(today);

            setSurgeon(undefined);
            setLocale(undefined);
            setScheduleId(undefined);
            setRequester(undefined);
            setPatient(undefined);
            setCreatedInitial(undefined);
            setCreatedFinal(undefined);
            setStatusBilling(undefined);
        }

        if (type === 'PROCEDRE_PENDING_TO_PAY') {
            const initial = new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().slice(0, 10)
            const end = new Date(new Date()).toISOString().slice(0, 10)
            setIsRedirect(true);
            setInitialDate(initial);
            setFinalDate(end);
            setStatusBilling(['pendingToPay', 'allpending']);
            setStatusFilter(['pending', 'inProgress', 'confirmed', 'finished', 'rescheduled']);
            setSurgeon(undefined);
            setLocale(undefined);
            setScheduleId(undefined);
            setRequester(undefined);
            setPatient(undefined);
            setCreatedInitial(undefined);
            setCreatedFinal(undefined);
        }

        if (type === 'PROCEDURE_TO_COFIRMSTION') {
            const initial = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10);
            const nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().slice(0, 10)
            setIsRedirect(true);
            setInitialDate(initial);
            setFinalDate(nextYear);
            setStatusFilter('pending');

            setSurgeon(undefined);
            setLocale(undefined);
            setScheduleId(undefined);
            setRequester(undefined);
            setPatient(undefined);
            setCreatedInitial(undefined);
            setCreatedFinal(undefined);
            setStatusBilling(undefined);
        }

        if (type === 'PROCEDURE_FINISH_YESTERDAY') {
            const yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().slice(0, 10)
            setIsRedirect(true);
            setInitialDate(yesterday);
            setFinalDate(yesterday);
            setStatusFilter('finished');

            setSurgeon(undefined);
            setLocale(undefined);
            setScheduleId(undefined);
            setRequester(undefined);
            setPatient(undefined);
            setCreatedInitial(undefined);
            setCreatedFinal(undefined);
            setStatusBilling(undefined);
        }

        if (type === 'PROCEDURE_NEXT_30_DAYS') {
            const today = new Date().toISOString().slice(0, 10)
            const nextMonth = new Date()
            nextMonth.setDate(nextMonth.getDate() + 29)
            const nextMonthDate = nextMonth.toISOString().slice(0, 10)

            setInitialDate(today);
            setFinalDate(nextMonthDate);

            setIsRedirect(true);
            setStatusFilter(['pending', 'inProgress', 'confirmed', 'finished', 'rescheduled']);

            setSurgeon(undefined);
            setLocale(undefined);
            setScheduleId(undefined);
            setRequester(undefined);
            setPatient(undefined);
            setCreatedInitial(undefined);
            setCreatedFinal(undefined);
            setStatusBilling(undefined);
        }

        navigate(page);
    }

    const loadPopup = async () => {
        try {
            console.log('[Popup] Iniciando carregamento...');
            const popup = await popupRegistry.get.execute();
            console.log('[Popup] Dados recebidos:', JSON.stringify(popup));
            if (popup?.enabled && popup?.text) {
                console.log('[Popup] enabled=true, abrindo modal com texto:', popup.text);
                setPopupText(popup.text);
                setPopupVisible(true);
            } else {
                console.warn('[Popup] Não exibido — enabled:', popup?.enabled, '| text:', popup?.text);
            }
        } catch (error) {
            console.error('[Popup] Erro no loadPopup:', error);
        }
    };

    React.useEffect(() => {
        loadCharts();
        loadPopup();
    }, []);

    return (
        <div style={{ width: '100%' }}>
            <Modal
                open={popupVisible}
                onOk={() => setPopupVisible(false)}
                onCancel={() => setPopupVisible(false)}
                okText="OK"
                cancelButtonProps={{ style: { display: 'none' } }}
                centered
                width={480}
                title={
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <WarningOutlined style={{ color: '#faad14', fontSize: 20 }} />
                        Aviso
                    </span>
                }
            >
                <p style={{ fontSize: 15, lineHeight: 1.6, marginTop: 8, whiteSpace: 'pre-line' }}>
                    {popupText}
                </p>
            </Modal>
            <Row gutter={16} style={{ width: '100%' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Card title="Quantidade de agendamentos para hoje" value={schedulesToday.total} onClick={() => goTo('/schedule', 'PROCEDURE_TODAY')} />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Card title="Procedimentos pendentes de pagamento" value={pendingToPay.total} onClick={() => goTo('/finance', 'PROCEDRE_PENDING_TO_PAY')} />
                </Col>
            </Row>
            <Row gutter={16} style={{ width: '100%' }}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Card title="Agendamentos pendentes de confirmação" value={pendingToConfirmation.total} onClick={() => goTo('/schedule', 'PROCEDURE_TO_COFIRMSTION')} />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Card title="Procedimentos concluídos na data de ontem" value={schedulesYesterday.total} onClick={() => goTo('/schedule', 'PROCEDURE_FINISH_YESTERDAY')} />
                </Col>
            </Row>
            <Row gutter={16}>
                <CardWithChart onClick={() => goTo('/schedule', 'PROCEDURE_NEXT_30_DAYS')} title="Agendamentos para os próximos 30 dias" data={
                    Array.isArray(schedulesNext30Days?.result)
                        ? schedulesNext30Days.result.filter(item => item.total > 0)
                        : []
                } total={schedulesNext30Days.total} />
            </Row>
        </div>
    )
}

export default Home;